/* unplugin-vue-components disabled */import { render } from "./RankListItem.vue?vue&type=template&id=585c92a6&scoped=true&ts=true"
import script from "./RankListItem.vue?vue&type=script&lang=ts"
export * from "./RankListItem.vue?vue&type=script&lang=ts"

import "./RankListItem.vue?vue&type=style&index=0&id=585c92a6&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585c92a6"]])

export default __exports__